module.exports = __webpack_public_path__ + "img/4.10a12c38.jpg";